/**
 * Service worker registration (HANDOFF §4.1).
 *
 * vite-plugin-pwa generates the service worker and exposes a virtual module for
 * registration. This wires up auto-update; the offline shell is precached by
 * Workbox (see vite.config.ts).
 */
import { registerSW } from 'virtual:pwa-register';

/** Register the service worker for offline support + auto-update. */
export function registerPwa(): void {
  // Auto-reload ONCE when a freshly deployed service worker takes control, so new
  // builds appear for returning visitors without a manual cache-bust (the Workbox
  // precache would otherwise keep serving the old build). Guarded against loops.
  if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  }

  // `registerSW` is a no-op in dev (devOptions.enabled = false).
  registerSW({
    immediate: true,
    onRegisteredSW(swUrl) {
      console.info('[pwa] service worker registered:', swUrl);
    },
    onRegisterError(error) {
      console.error('[pwa] service worker registration failed:', error);
    },
  });
}
